import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import PrivateRoute from './PrivateRoute';
import { useDocumentTitle } from '../utils/useDocumentTitle';

// Lazy load all task components
const CreatedTasks = LazyComponentWithSuspense(() => import('../pages/CreatedTasks'));
const AssignedTasks = LazyComponentWithSuspense(() => import('../pages/AssignedTasks'));
const TaskDetails = LazyComponentWithSuspense(() => import('../pages/Task/ViewTask'));
const TaskProgress = LazyComponentWithSuspense(() => import('../pages/Task/TaskProgress'));
const EditTask = LazyComponentWithSuspense(() => import('../pages/Task/CreateEditTask'));
const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));

export const TaskRoutes = () => {
  useDocumentTitle('Task');
  return (
    <Routes>
      <Route path="/created" element={<CreatedTasks />} />
      <Route path="/assigned" element={<AssignedTasks />} />
      <Route path="/:id" element={<TaskDetails />} />
      <Route path="/:id/:userId" element={<TaskDetails />} />
      <Route path="/progress/:id" element={<TaskProgress />} />
      <Route
        path="/edit/:id"
        element={
          <PrivateRoute accessibleTo={['SUPERADMIN', 'ADMIN', 'CREATOR']} notCoursePage={true}>
            <EditTask />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
